export const FAQ_PAGE_HERO = {
  label: "FAQ",
  title: "자주 묻는 질문",
  description:
    "교육 수강 및 수료증 발급 관련\n자주 문의되는 내용을 빠르게 확인하실 수 있습니다",
};

export const FAQ_FETCH_SORT = "desc";

// 서버 페이지네이션: 한 페이지당 조회 건수 (제작업체 요청 10~20건 범위)
export const FAQ_POSTS_PER_PAGE = 10;

// 검색어 입력 디바운스(ms) — 매 글자 서버 요청 방지
export const FAQ_SEARCH_DEBOUNCE_MS = 300;
